// context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import instance from '../config';
import {
    guardarSesionVerificada,
    leerSesionVerificada,
    limpiarSesion,
    obtenerToken,
} from '../helpers/tokenSesion';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSuper, setIsSuper] = useState(false);
    const [loading, setLoading] = useState(true);
    const [idUser, setIdUser] = useState('');
    const [nombreUsuario, setNombreUsuario] = useState('');

    const cerrarSesionLocal = () => {
        limpiarSesion();
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsSuper(false);
        setNombreUsuario('');
    };

    const aplicarSesion = (datos) => {
        setIsAuthenticated(true);
        const rol = datos?.rol?.toLowerCase();
        setIsAdmin(rol === "admin" || rol === "super");
        setIsSuper(rol === "super");
        setIdUser(datos?.id);
        setNombreUsuario(datos?.name || '');
    };

    const checkAuth = () => {
        const token = obtenerToken();

        if (!token) {
            cerrarSesionLocal();
            setLoading(false);
            return;
        }

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Date.now() / 1000;
            const exp = payload.exp > 1e12 ? payload.exp / 1000 : payload.exp;
            if (!payload || exp <= currentTime) {
                cerrarSesionLocal();
                setLoading(false);
                return;
            }

            instance.get("/auth/login/verify-token")
                .then((res) => {
                    aplicarSesion(res.data.data);
                    guardarSesionVerificada(res.data.data);
                })
                .catch((error) => {
                    // Sin internet (no hubo respuesta del servidor): se mantiene la
                    // sesión ya iniciada mientras el token siga vigente.
                    const sesionGuardada = !error?.response && leerSesionVerificada();
                    if (sesionGuardada && sesionGuardada.id === payload.sub) {
                        aplicarSesion(sesionGuardada);
                        return;
                    }
                    cerrarSesionLocal();
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            cerrarSesionLocal();
            setLoading(false);
        }
    };

    // 🧠 Se ejecuta al montar y cada vez que cambia la ruta
    useEffect(() => {
        checkAuth();

    }, []); //

    return (
        <AuthContext.Provider value={{ setIsAdmin, setIsAuthenticated, idUser, nombreUsuario, isAuthenticated, isAdmin, loading, setLoading, checkAuth,isSuper }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
